<template>
  <div class="lib__form__main" data-cy="synergrid-config-component">
    <ValidationObserver ref="validator" slim>
      <div class="lib__form__main__content">
        <header class="lib__form__main__header">
          <h2 class="lib__h2">{{ $t('wantedConfiguration.title') }}</h2>
        </header>
        <div class="lib__feedback lib__feedback--alert" data-cy="meter-warning-synergrid">
          <div class="lib__feedback__icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <div class="lib__feedback__content">
            <p v-html="$t('meter.warningSynergrid')"></p>
          </div>
        </div>

        <div class="lib__panel">
          <header class="lib__panel__header">
            <div class="lib__panel__header__icon">
              <img :src="require('@ores/css-library/assets/img/icons/electricity_outline.svg')" alt="Electicity" />
            </div>
            <h3 class="lib__h3">{{ $t('energy.electricity') }}</h3>
          </header>

          <div class="lib__panel__main lib__panel__main--form">
            <synergrid-request-type-selector data-cy="synergrid-request-type" v-model="configurationInfo.changeType"></synergrid-request-type-selector>

            <synergrid-new-request-form data data-cy="synergrid-new-request-form" v-if="configurationInfo.changeType === 0" v-model="configurationInfo.newRequestInfo"></synergrid-new-request-form>
            <synergrid-move-request-form data-cy="synergrid-move-request-form" v-if="configurationInfo.changeType === 1" v-model="configurationInfo.moveRequestInfo"></synergrid-move-request-form>
            <synergrid-enhance-request-form data-cy="synergrid-enhance-request-form" v-if="configurationInfo.changeType === 2" v-model="configurationInfo.enhanceRequestInfo"></synergrid-enhance-request-form>
            <synergrid-remove-request-form data-cy="synergrid-remove-request-form" v-if="configurationInfo.changeType === 3" v-model="configurationInfo.removeRequestInfo"></synergrid-remove-request-form>
            <synergrid-modify-ref-request-form data-cy="synergrid-modify-ref-request-form" v-if="configurationInfo.changeType === 4" v-model="configurationInfo.modifyRefRequestInfo"></synergrid-modify-ref-request-form>
          </div>
        </div>

        <fieldset class="lib__form__fieldset">
          <legend class="lib__form__legend">{{ $t('synergrid.config.wantedDates') }}</legend>
          <monthly-selector :month.sync="configurationInfo.month" :year.sync="configurationInfo.year" :years="5" data-cy="synergrid-wanted-period" required></monthly-selector>
          <collapsable-text-area :max='500' :add-label="$t('meter.form.remarks')" :label="$t('meter.form.remarks')" v-model="configurationInfo.remark"></collapsable-text-area>
        </fieldset>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import { helper, idGenerator } from '@/services'
import Step from '@/components/steps/Step'
import SynergridNewRequestForm from '@/components/inputs/Configuration/SynergridNewRequestForm.vue'
import SynergridMoveRequestForm from '@/components/inputs/Configuration/SynergridMoveRequestForm.vue'
import SynergridEnhanceRequestForm from '@/components/inputs/Configuration/SynergridEnhanceRequestForm.vue'
import SynergridRemoveRequestForm from '@/components/inputs/Configuration/SynergridRemoveRequestForm.vue'
import SynergridModifyRefRequestForm from '@/components/inputs/Configuration/SynergridModifyRefRequestForm.vue'
import SynergridRequestTypeSelector from '@/components/inputs/Configuration/SynergridRequestTypeSelector.vue'
import { State, Mutation } from 'vuex-class'
import { SynergridConfigurationInfo } from '@/models'

@Component({
  name: 'configuration-info-step',
  components: {
    SynergridNewRequestForm,
    SynergridMoveRequestForm,
    SynergridEnhanceRequestForm,
    SynergridRemoveRequestForm,
    SynergridModifyRefRequestForm,
    SynergridRequestTypeSelector,
  }
})
export default class ConfigurationInfoStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'synergridConnection' })
  public requestId!: string
  @State('configurationInfo', { namespace: 'synergridConnection/configurationInfo' })
  public configurationInfoState!: SynergridConfigurationInfo | null

  public configurationInfo: SynergridConfigurationInfo = {
    changeType: null,
    newRequestInfo: { synergridRef: null, group: null, power: null },
    moveRequestInfo: { ean: null },
    enhanceRequestInfo: { group: null, power: null },
    removeRequestInfo: { ean: null },
    modifyRefRequestInfo: { oldRef: null, oldGroup: null, newRef: null, newGroup: null },

    month: null,
    year: null,
    remark: null
  }

  public fieldId: string = idGenerator.getId()
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'synergridConnection/configurationInfo' })
  private store!: (index: SynergridConfigurationInfo | null) => void
  //#endregion

  //#region [Computed]
  public get years(): Array<{ text: string; value: string }> {
    const years = [] as Array<{ text: string; value: string }>
    const currentYear = new Date().getFullYear()
    for (let i = 0; i < 5; i++) {
      years.push({ text: (currentYear + i).toString(), value: (currentYear + i).toString() })
    }
    return years
  }
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
    if (this.configurationInfoState !== null) {
      this.configurationInfo = helper.clone(this.configurationInfoState)
    }
  }

  public async save(next: boolean, isValid: boolean) {
    if (isValid) {
      this.$appInsights.trackEvent('WR_SC_StepConfigurationInfo_Validated', {
        Segment: 'WR_SC',
        WebRef: this.requestId
      })
    }

    this.store(this.configurationInfo)
  }
  //#endregion
}
</script>